/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Backdrop,
  Paper,
  Typography,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import Actions from "../../../fluid/Actions/ActionFactory";

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#dc004e",
    },
  },
});

const styles = (theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
});

class CreateEventGroup extends Component {
  state = {
    adding_group: false,
    name: null,
    error: null,
  };

  createGroup = () => {
    this.setState(
      {
        adding_group: true,
      },
      () => {
        Actions("http_request", {
          url: "/sainapse/event_group",
          method: "post",
          data: {
            name: this.state.name,
            parent_event_group_name: "root",
          },
        })
          .then((res) => {
            console.log("ev group res", res);
            this.setState(
              {
                ...this.state,
                name: res.data.result.name,
                adding_group: false,
              },
              () => this.closeDialog()
            );
          })
          .catch((err) => {
            let response = err.response.data;
            let errorMessage = "";
            if (Array.isArray(response.errors)) {
              let nameError = response.errors.find(
                (error) => error.attribute == "name"
              );
              if (nameError) {
                errorMessage = nameError.message;
              }
            } else if (response.message) {
              errorMessage = response.message;
            } else {
              errorMessage = "Error creating Event Group.";
            }
            this.setState({
              ...this.state,
              adding_group: false,
              error: errorMessage,
            });
          });
      }
    );
  };

  closeDialog = () => {
    this.setState(
      {
        ...this.state,
        adding_group: false,
        name: null,
        error: null,
      },
      () => this.props.close()
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <ThemeProvider theme={blue_theme}>
        <Dialog style={{ zIndex: this.props.zIndex }} open={this.props.open}>
          <DialogTitle>Create Event Group</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Event groups should have a unique name. Event groups can hold
              events under them.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Event Group Name"
              fullWidth
              value={this.state.name}
              onChange={(event) =>
                this.setState({ ...this.state, name: event.target.value })
              }
            />
            <Typography variant="caption" color="secondary">
              {this.state.error}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              startIcon={
                this.state.adding_group ? (
                  <CircularProgress color="primary" size={20} />
                ) : null
              }
              onClick={this.createGroup}
            >
              Create
            </Button>
            <Button color="secondary" onClick={this.closeDialog}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  }
}

export default withStyles(styles)(CreateEventGroup);
